var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.5C19.9036 25.5 25.5 19.9036 25.5 13C25.5 6.09644 19.9036 0.5 13 0.5C6.09644 0.5 0.5 6.09644 0.5 13C0.5 19.9036 6.09644 25.5 13 25.5Z",
    fill: "#FEF5F4",
    stroke: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 13.14C19.0001 12.72 18.9701 12.31 18.8901 11.89H13.1201V14.25H16.4301C16.2901 15.01 15.8501 15.68 15.2101 16.11V17.64H17.1801C18.3301 16.58 19.0001 15 19.0001 13.14Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.12 19.12C14.77 19.12 16.16 18.58 17.18 17.64L15.21 16.11C14.66 16.48 13.95 16.7 13.13 16.7C11.53 16.7 10.18 15.62 9.69003 14.17H7.66003V15.75C8.69003 17.82 10.81 19.12 13.12 19.12Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68006 14.17C9.42006 13.41 9.42006 12.59 9.68006 11.83V10.25H7.65006C6.78006 11.98 6.78006 14.02 7.65006 15.75L9.68006 14.17Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.12 9.30003C13.99 9.29003 14.84 9.62003 15.47 10.22L17.22 8.47003C16.11 7.43003 14.64 6.86003 13.12 6.88003C10.81 6.88003 8.69002 8.19003 7.65002 10.25L9.68002 11.83C10.17 10.38 11.52 9.30003 13.12 9.30003Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.337dcb79e82f21804486854c22f586aa.svg";
export { ForwardRef as ReactComponent };